import React from "react";
import { Link } from "react-router-dom";
import Cta from "../../Shared/Cta";
const AddnewBook = () => {
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Library</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Add New Book</li>
        </ul>
      </div>

      <div class="card height-auto">
        <div class="card-body">
          <div class="heading-layout1">
            <div class="item-title">
              <h3>Add New Book</h3>
            </div>
            <Cta />
          </div>
          <form class="new-added-form">
            <div class="row">
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>Book Name *</label>
                <input type="text" placeholder="" class="form-control" />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>Subject *</label>
                <input type="text" placeholder="" class="form-control" />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>Writter Name *</label>
                <input type="text" placeholder="" class="form-control" />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>Class *</label>
                <select class="select2">
                  <option value="">Please Select Class *</option>
                  <option value="1">Play</option>
                  <option value="2">Nursery</option>
                  <option value="3">One</option>
                  <option value="3">Two</option>
                  <option value="3">Three</option>
                  <option value="3">Four</option>
                  <option value="3">Five</option>
                </select>
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>ID No</label>
                <input type="text" placeholder="" class="form-control" />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>Publishing Date *</label>
                <input type="text" placeholder="" class="form-control" />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <label>Uploade Date *</label>
                <input type="text" placeholder="" class="form-control" />
              </div>
              <div class="col-md-3 d-none d-xl-block form-group"></div>
              <div class="col-12 form-group mg-t-8">
                <button
                  type="submit"
                  class="btn-fill-lg btn-gradient-yellow btn-hover-bluedark"
                >
                  Save
                </button>
                <button
                  type="reset"
                  class="btn-fill-lg bg-blue-dark btn-hover-yellow"
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddnewBook;
